import { useState } from "react";
import { CheckBox } from "../Common/Checkbox";

export function CheckboxFilterCollection({ setFilterValues, category, constraints }: { setFilterValues: (subjects: string[]) => void, category:string,constraints: string[]}) {

    const [showMore, setShowMore] = useState(false);
    const [selectedCheckboxes] = useState(new Set<string>());
    function toggleCheckbox(label:string, val:boolean){
        const lowerLabel = label.toLowerCase();
        if (selectedCheckboxes.has(lowerLabel) && val === false) {
            selectedCheckboxes.delete(lowerLabel);
        } else {
            selectedCheckboxes.add(lowerLabel);
        }
        setFilterValues(Array.from(selectedCheckboxes));
    }

    const createCheckbox = (label: string) =>  {
        if (selectedCheckboxes.has(label.toLowerCase())) {
            return (<CheckBox
                name={label}
                label={label}
                onValueChange={toggleCheckbox}
                key={label}
                defaultValue={true}
            />)
        }
        return (<CheckBox
            name={label}
            label={label}
            onValueChange={toggleCheckbox}
            key={label}
        />)
    }

    const handleShowMore = () => {
        setShowMore(!showMore);
    }
    return (
        <>
            <div className="at-header mb-1">{category}</div>
            {showMore ? constraints.map(constraint => createCheckbox(constraint)) : constraints.slice(0, 5).map(constraint => createCheckbox(constraint))}
            {showMore ? <div className="cursor-pointer text-sm" onClick={handleShowMore}>Show Less</div> : <div className="cursor-pointer text-sm" onClick={handleShowMore}>Show More</div>}
        </>
    );
}